import React, { Component } from 'react';
import { Input, Select, Button, DatePicker, Icon } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import SelectProvince from '../../common/SelectProvince';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class EmployeeFilter extends Component {

    search = () => {
        // const {
        //     searchParams,
        //     searchParams: {
        //         areaParams,
        //     },
        // } = this.state;
        // this.props.search({ ...searchParams, ...areaParams, areaParams: '', hasCheckedArea: '' });
        this.props.search();
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.props;
        searchParams[field] = e.target.value;
        this.props.onChange(searchParams);
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.props;
        if (field == 'enterpriseDepartmentId') {
            searchParams[field] = value;
            searchParams.xjDeptId = undefined;
            searchParams.xjDeptName = undefined;
            searchParams.positionId = undefined;
            searchParams.positionName = undefined;
        } else {
            searchParams[field] = value;
        }
        this.props.onChange(searchParams);
    }

    saveProvince = (checkedArea) => {
        const { searchParams } = this.props;
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.props.onChange({
            ...searchParams,
            areaParams,
            hasCheckedArea,
            areaName: areaList.join(','),
        });
    }

    handleSearchRetrieveChange = (option, key) => {
        const { searchParams } = this.props;
        const { value, text } = option || {};
        switch (key) {
            case 'xjDept':
                searchParams.xjDeptId = value;
                searchParams.xjDeptName = text;
                searchParams.positionId = undefined;
                searchParams.positionName = undefined;
                break;
            case 'position':
                searchParams.positionId = value;
                searchParams.positionName = text;
                break;
            case 'leader':
                searchParams.leaderId = value;
                searchParams.leaderName = text;
                break;
            default:
                break;
        }
        this.props.onChange(searchParams);
    }

    render() {
        const {
            searchParams,
            enterpriseDepartmentList,
            roleCodeList,
            hideRoleCode,
        } = this.props;
        const { 
            employeeCode,
            userCompellation,
            companyName,
            areaName,
            hasCheckedArea = [],
            enterpriseDepartmentId,
            xjDeptId,
            positionName,
            leaderName,
            roleCode,
        } = searchParams || {};
        const enterpriseDepartmentOptions = enterpriseDepartmentList.map(el => <Option value={el.value}>{el.label}</Option>)
        const roleCodeOptions = roleCodeList.map(el => <Option value={el.value}>{el.label}</Option>)
        return (
            <div>
                <div className="search-bar bar2 expand" style={{ marginBottom: 10, maxHeight: 280 }}>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">工号</label>
                    <Input
                        placeholder="请输入"
                        value={employeeCode}
                        style={{ width: 120 }}
                        onChange={e => this.handleInputChange(e, 'employeeCode')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">姓名</label>
                    <Input
                        placeholder="请输入"
                        style={{ width: 120 }}
                        value={userCompellation}
                        onChange={e => this.handleInputChange(e, 'userCompellation')}
                    />
                </div>
                {/* <div className="search-item">
                    <label htmlFor="" className="ui-label">公司名称</label>
                    <Input
                        placeholder="请输入"
                        style={{ width: 140 }}
                        value={companyName}
                        onChange={e => this.handleInputChange(e, 'companyName')}
                    />
                </div> */}
                <div className="search-item">
                    <label htmlFor="" className="ui-label">部门</label>
                    <Select
                        style={{ width: 160 }}
                        allowClear={true}
                        placeholder="请选择"
                        value={enterpriseDepartmentId}
                        onChange={value => this.handleSelectChange(value, 'enterpriseDepartmentId')}
                    >
                        {enterpriseDepartmentOptions}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">下级组织</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 142 }}
                        placeholder="输入下级组织检索"
                        value={xjDeptId}
                        params={{ limit: 20, level: 6, parentId: enterpriseDepartmentId }}
                        url={API_URL.user.queryUserDepartmentSelect}
                        config={{ id: 'enterpriseDepartmentId', name: 'enterpriseDepartmentName' }}
                        onChange={(option) => this.handleSearchRetrieveChange(option, 'xjDept')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">职位级别</label>
                    <SearchRetrieve
                        keyword='positionName'
                        style={{ width: 142 }}
                        placeholder="输入职位检索"
                        value={positionName}
                        params={{ limit: 20, enterpriseDepartmentId: xjDeptId ? xjDeptId : enterpriseDepartmentId}}
                        url={API_URL.team.queryUserPositionSelect}
                        config={{ id: 'positionId', name: 'positionName' }}
                        onChange={(option) => this.handleSearchRetrieveChange(option, 'position')}
                    />
                </div>
                {!hideRoleCode && (
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">职位角色</label>
                        <Select
                            style={{ width: 160 }}
                            allowClear={true}
                            placeholder="请选择"
                            value={roleCode}
                            onChange={value => this.handleSelectChange(value, 'roleCode')}
                        >
                            {roleCodeOptions}
                        </Select>
                    </div>
                )}
                <div className="search-item">
                    <label className="ui-label">主管领导</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 160 }}
                        placeholder="输入姓名/工号检索"
                        value={leaderName}
                        params={{ limit: 20 }}
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={(option) => this.handleSearchRetrieveChange(option, 'leader')}
                    />
                </div>
                <div className="search-item">
                    <label className="ui-label">区域/城市</label>
                    <SelectProvince areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} />
                </div>
                <div className="search-item" style={{ textAlign:'right' }}>
                    <Button type="primary" style={{ margin:'0 10px'}} onClick={this.search}>搜索</Button>
                </div>
            </div>
            </div>
            
        );
    }
}

export default EmployeeFilter




// WEBPACK FOOTER //
// ./src/components/documentManagement/departmentalDocuments/EmployeeFilter.js